export default "__VITE_ASSET__xuDX4f94__"